const ApartmentStatusColorEnum = {
  APARTMENT_EMPTY: 1,
  APARTMENT_CHECKED_IN: 2,
  APARTMENT_IS_CLEANING: 3,
  APARTMENT_WAITING_FOR_CLEANING: 4,
  APARTMENT_WAITING_CHECK_IN: 5
}
export default ApartmentStatusColorEnum


// WEBPACK FOOTER //
// ./src/enum/apartmentStatusColorEnum.js